module.exports = __webpack_public_path__ + "static/media/female3.482d7225.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/body-model/female3.png
// module id = 900
// module chunks = 0